// AUDIKIT — agrandissement des photos du bloc « Compatible avec ces appareils »
// (blocks/audikit-compatibility.liquid).
//
// Chargé sur toutes les pages par snippets/audikit-global-scripts.liquid, et
// non plus dans un {% javascript %} du bloc : l'« ajout rapide » des pages
// collection recopie le bloc dans une fenêtre, mais le thème ne charge sur une
// page que le JavaScript des blocs qui y sont rendus (5 oct. 2026).
//
// Délégation sur document, en phase de bouillonnement : la section produit est
// régénérée par morph à chaque changement de variante, des écouteurs posés sur
// les bulles elles-mêmes seraient perdus. Sans JavaScript, ou sur un navigateur
// sans <dialog>, chaque bulle reste un lien qui ouvre simplement la photo.

if (!window.akCompatZoom) {
  window.akCompatZoom = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const opener = target.closest('[data-ak-zoom]');
    if (opener instanceof HTMLElement) {
      // Dans la fenêtre d'ajout rapide, le bloc est recopié : on cherche le
      // <dialog> voisin de la bulle cliquée plutôt que par identifiant, qui peut
      // exister deux fois (page produit en arrière-plan, fenêtre au premier plan).
      const scope = opener.closest('.ak-compat');
      const dialog =
        scope?.querySelector('dialog.ak-compat__dialog') ?? document.getElementById(opener.dataset.akZoom || '');
      if (!(dialog instanceof HTMLDialogElement) || typeof dialog.showModal !== 'function') return;
      event.preventDefault();

      const year = opener.dataset.year;
      const img = dialog.querySelector('.ak-compat__dialog-img');
      if (img instanceof HTMLImageElement) img.src = opener.dataset.src || '';
      const brand = dialog.querySelector('.ak-compat__dialog-brand');
      if (brand) brand.textContent = opener.dataset.brand || '';
      const title = dialog.querySelector('.ak-compat__dialog-title');
      if (title) title.textContent = opener.dataset.model || '';
      const yearEl = dialog.querySelector('.ak-compat__dialog-year');
      if (yearEl instanceof HTMLElement) {
        // Libellé traduit posé par le Liquid (« Sorti en %Y% »), français en secours.
        const label = dialog.dataset.yearLabel || 'Sorti en %Y%';
        yearEl.textContent = year ? label.replace('%Y%', year) : '';
        yearEl.hidden = !year;
      }

      dialog.showModal();
      return;
    }

    if (target.closest('[data-ak-zoom-close]')) {
      target.closest('dialog')?.close();
      return;
    }

    // Clic sur le fond assombri : la cible est le <dialog> lui-même, le contenu
    // étant dans .ak-compat__dialog-inner.
    if (target instanceof HTMLDialogElement && target.classList.contains('ak-compat__dialog')) {
      target.close();
    }
  });
}
